
//get base path for routes

export function getBasePath(){


//console.log(window.location.pathname.split('/'));

if(window.location.pathname.includes('/branch/')){

	var bp = window.location.pathname.split('/');
	//we have a branch generate a new base path for routes
	return  bp[1] + '/' + bp[2] + '/';




} else {return '/'}


}


export default {

	methods:{
			getBasePath

	}

}